
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class EmployeeAdvanceDialog extends Serenity.EntityDialog<EmployeeAdvanceRow, any> {
        protected getFormKey() { return EmployeeAdvanceForm.formKey; }
        protected getIdProperty() { return EmployeeAdvanceRow.idProperty; }
        protected getLocalTextPrefix() { return EmployeeAdvanceRow.localTextPrefix; }
        protected getNameProperty() { return EmployeeAdvanceRow.nameProperty; }
        protected getService() { return EmployeeAdvanceService.baseUrl; }
        protected getDeletePermission() { return EmployeeAdvanceRow.deletePermission; }
        protected getInsertPermission() { return EmployeeAdvanceRow.insertPermission; }
        protected getUpdatePermission() { return EmployeeAdvanceRow.updatePermission; }

        protected form = new EmployeeAdvanceForm(this.idPrefix);

    }
}